import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class Callmode 
{
    constructor(private _notifier : NotifierManager) {}

    lGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.CALLMODE_L_GENERIC)
    }

    lNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.CALLMODE_L_NOT_AUTH)
    }

    uGeneric()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.CALLMODE_U_GENERIC)
    }

    uNotAuth()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.CALLMODE_U_NOT_AUTH)
    }
}